module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/The-Story-of-God.23f35aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/The-Story-of-God.jpg
// module id = 7dvr
// module chunks = 0